import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import axios from "axios";
import { getToken, getSession } from "./../../Utils/SessionUtils";
import { t } from "i18next";

const api_url = process.env.REACT_APP_API_BASE_URL_V1;
const config = {
  headers: { Authorization: `Bearer ${getToken()}` },
};

/**
 * It gets all the autorisation from the database.
 * @returns The response is an array of objects.
 */
export async function getAllAutorisation() {
  try {
    const response = await axios.get(api_url + "autorisation/codeimg/" + getSession("code_generated"), config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

/**
 * Accept an autorisation request
 * @param id - id of the autorisation
 * @param etat - the new status of the autorisation
 * @returns The response from the server.
 */
export async function acceptAutorisation(id, etat) {
  const credentiel = {
    id: id,
    type: "autorisation",
    etat: etat,
  };
  try {
    const response = await axios.put(api_url + "autorisation/updatestatus", credentiel, config);
    // console.log(response);
    // toast.success("Congé accepté");
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      toast.error(t("error server"));
      console.log(error.response.data);
      console.log(error.response.message);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the
      // browser and an instance of
      // http.ClientRequest in node.js
      toast.error(t("error request"));
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(t("Error"), error.message);
    }
    console.log(error.config);
    return error;
  }
}

/**
 * It gets the autorisation for a user.
 * @param userId - The userId of the user you want to get the autorisation for.
 * @returns The response is an array of autorisation objects.
 */
export async function getAutorisationByUserId(userId) {
  try {
    const response = await axios.get(api_url + "autorisation/usercode/" + userId, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

/**
 * add Autorisation
 */
export async function addAutorisation(data) {
  try {
    const response = await axios.post(api_url + "autorisation/" , data,config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

/**
 * It gets the autorisation for a user by filtre 
 * @param userId - The userId of the user you want to get the autorisation for.
 * @returns The response is an array of autorisation objects.
 */
export async function getAutorisationByCodeIdFiltre(user,date_debut ,date_fin) {
  try {
    
    const response = await axios.get(api_url + `autorisation/usercode/${user}/${date_debut}/${date_fin}` , config);
    return response;
  } catch (error) {
    console.error(error);
  }
}
/**
 * Send a notification to a specific user
 * @param text - The text of the notification.
 * @param receiver - The receiver of the notification.
 * @returns The response from the server.
 */
export async function senFcmAutorisation(text, receiver) {
  const notification = {
    data: {
      title: "Autorisation",
      message: text,
    },
    to: "/topics/" + localStorage.getItem("code_generated") + "user" + receiver,
  };
  const fcm_server_key =
    "AAAAyFwzY3I:APA91bGIPThuQusFacH13cip7zdnDNY81mhV1xJV5pQXjqoHaIUwcibidgFahbxnjAxWODcIR0pew1a3tYlVUQNPLpx7nIanisZieGr0ZaMcwSqDvmcvyr9YjJK3yfoEbwu82sWDhL7E";

  const g = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `key=${fcm_server_key}`,
    },
  };
  try {
    const response = await axios.post("https://fcm.googleapis.com/fcm/send", notification, g);
    toast.success("Notification envoyée");
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      toast.error(t("error server"));
      console.log(error.response.data);
      console.log(error.response.message);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the
      // browser and an instance of
      // http.ClientRequest in node.js
      toast.error(t("error request"));
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(t("Error"), error.message);
    }
    console.log(error.config);
    return error;
  }
}
